__turbopack_context__.v({
  "root": "MobileWalletButton-module-scss-module__fGcgLW__root",
});
